import React from 'react';
import { observer } from 'mobx-react-lite';
import { Drawer, Text, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useStore } from '../../state';
import { CartView } from './CartView';
import { THEME_COLORS } from '../../theme/ThemeConstants';
import { Z_INDEX } from '../../components/layout/LayoutConstants';

// A single, route-independent cart surface. Mounted once globally (Application.tsx)
// so the cart is reachable from any page — the product page in particular has no
// sidebar cart of its own. Reuses the existing self-contained <CartView>.
export const GlobalCartDrawer: React.FC = observer(() => {
  const { applicationStore, cartStore } = useStore();
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);

  return (
    <Drawer
      opened={applicationStore.isCartOpen}
      onClose={() => applicationStore.closeCart()}
      position={isMobile ? 'bottom' : 'right'}
      size={isMobile ? '85%' : 420}
      zIndex={Z_INDEX.CART_DRAWER}
      title={
        <Text fw={700} c={THEME_COLORS.text.primary}>
          Cart ({cartStore.totalQuantity})
        </Text>
      }
      styles={{
        header: {
          backgroundColor: 'rgba(15, 15, 15, 0.6)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          borderBottom: `1px solid ${THEME_COLORS.border.secondary}`
        },
        content: {
          backgroundColor: THEME_COLORS.background.tertiary,
          display: 'flex',
          flexDirection: 'column'
        },
        body: {
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          padding: 16
        },
        close: {
          color: THEME_COLORS.text.primary
        }
      }}
    >
      <CartView isMobile={false} />
    </Drawer>
  );
});
